'use client';

import { useState, useCallback } from 'react';
import { clsx } from 'clsx';

import { HeaderCompactStoryblok, Locales } from '@monoimin/sb-types';
import { Modal } from '@monoimin/molecules/Modal';
import { usePathnameChange } from '@monoimin/hooks';

import { HeaderBody } from './components/HeaderBody';
import { ShiftMenuPanel } from './components/ShiftMenuPanel';
import { DisclosureMenuPanel } from './components/DisclosureMenuPanel';
export type HeaderCompactСustomizationProps = {
  classNames?: {
    header?: string;
    headerBody?: string;
    headerLink?: string;
    logoLink?: string;
    logoImage?: string;
    logoContainer?: string;
    contactsContainer?: string;
    panel?: string;
  };
  logoSrc?: string;
  logoAlt?: string;
  localesList?: ReadonlyArray<{ title: string; locale: Locales }>;
  panelVariant: 'shift' | 'disclosure';
  logoLinkHref?: string;
  disclosureTransitionProps?: {
    show?: boolean;
  };
};

export type HeaderCompactProps = HeaderCompactСustomizationProps & {
  blok: HeaderCompactStoryblok;
  activeLocale: string;
};

export type MenuPanelProps = Pick<HeaderCompactProps, 'blok' | 'localesList'>;

/**
 * Обязательные стили для компонента: button, listbox
 * Основной медиа параметр: min-[1200px]
 */
export function HeaderCompact({
  blok,
  activeLocale,
  logoSrc,
  logoAlt,
  localesList,
  panelVariant,
  classNames = {},
  disclosureTransitionProps,
}: HeaderCompactProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const onCloseModal = useCallback(() => setMenuOpen(false), []);

  usePathnameChange(onCloseModal);

  return (
    <>
      <header className={clsx('header', classNames?.header)}>
        <HeaderBody
          blok={blok}
          activeLocale={activeLocale}
          logoSrc={logoSrc}
          logoAlt={logoAlt}
          localesList={localesList}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          classNames={classNames}
        />
      </header>
      <Modal
        isOpen={menuOpen}
        setIsOpen={setMenuOpen}
        panelClassName={clsx('header-panel', classNames?.panel)}
      >
        <div className='header-panel-header'>
          <HeaderBody
            blok={blok}
            activeLocale={activeLocale}
            logoSrc={logoSrc}
            logoAlt={logoAlt}
            localesList={localesList}
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            classNames={{
              ...classNames,
              contactsContainer: clsx(
                'text-white hidden',
                classNames?.contactsContainer
              ),
            }}
          />
        </div>
        {panelVariant === 'shift' && (
          <ShiftMenuPanel blok={blok} localesList={localesList} />
        )}
        {panelVariant === 'disclosure' && (
          <DisclosureMenuPanel
            blok={blok}
            localesList={localesList}
            disclosureTransitionProps={disclosureTransitionProps}
          />
        )}
      </Modal>
    </>
  );
}
